<template>
  <Toolbar class="mb-4 md:w-11">
    <template #start>
      <div class="flex-column align-items-center">
        <div class="vacation-summary flex flex-row">
          <div v-if="loading" class="flex align-items-center">
            <Skeleton width="10rem" height="1.5em" class="mr-2" />
          </div>
          <p v-else class="summary-item">
            <strong>{{ vacationBalance }}</strong> días disponibles.
          </p>
          <InfoButton :message="infoMessage" />
        </div>
      </div>
    </template>
    <template #end>
      <Button
        label="Nueva solicitud"
        icon="pi pi-plus"
        severity="primary"
        class="mr-2 font-semibold text-sm"
        @click="emit('new-request')"
      />
    </template>
  </Toolbar>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import Toolbar from 'primevue/toolbar'
  import Button from 'primevue/button'
  import Skeleton from 'primevue/skeleton'
  import InfoButton from '@/shared/components/InfoButton.vue'

  const props = defineProps<{
    vacationBalance: number | string
    infoHint?: string
    loading?: boolean
  }>()

  const emit = defineEmits<{
    (event: 'new-request'): void
  }>()

  const infoMessage = computed(
    () =>
      props.infoHint ??
      'El saldo será actualizado una vez que las vacaciones sean procesadas en el sistema de nomina'
  )
</script>
